import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

export function EnterpriseBadge() {
  const { t } = useTranslation('entity-portal');

  return (
    <Box
      role="status"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        px: 2,
        py: 0.75,
        borderRadius: 999,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: (theme) =>
          alpha(
            theme.palette.background.paper,
            theme.palette.mode === 'dark' ? 0.78 : 0.85,
          ),
      }}
    >
      <Box
        aria-hidden
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          bgcolor: 'success.main',
          boxShadow: (theme) =>
            `0 0 0 3px ${alpha(theme.palette.success.main, 0.2)}`,
        }}
      />
      <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
        {t('login.loginEnterpriseSsoEnabled')}
      </Typography>
    </Box>
  );
}
